import { motion, AnimatePresence } from 'framer-motion';
import type { ControlInfoEntry } from '../../lib/controlOptionInfo';

type Props = {
  entry: ControlInfoEntry | null;
  onClose: () => void;
};

export function ControlInfoSheet({ entry, onClose }: Props) {
  return (
    <AnimatePresence>
      {entry && (
        <>
          <motion.button
            type="button"
            aria-label="Закрыть"
            className="fixed inset-0 z-[60] bg-black/55"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          <motion.div
            role="dialog"
            aria-modal
            className="fixed left-3 right-3 z-[61] rounded-2xl px-4 py-4 max-h-[70vh] overflow-y-auto"
            style={{
              bottom: 'calc(env(safe-area-inset-bottom, 0px) + 5.5rem)',
              background: 'rgba(10,25,47,0.96)',
              backdropFilter: 'blur(20px)',
              WebkitBackdropFilter: 'blur(20px)',
              border: '1px solid var(--border-glass)',
              boxShadow: '0 12px 40px rgba(0,0,0,0.45)',
            }}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 16 }}
            transition={{ duration: 0.32, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="flex items-start gap-3">
              <span className="text-2xl shrink-0" aria-hidden>{entry.icon}</span>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-bold" style={{ color: 'var(--text-1)' }}>{entry.title}</p>
                <p className="text-xs mt-2 leading-relaxed" style={{ color: 'var(--text-2)' }}>{entry.body}</p>
              </div>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="press mt-4 w-full py-2.5 rounded-xl text-xs font-semibold"
              style={{
                background: 'rgba(99,179,237,0.18)',
                color: 'var(--cyan-bright)',
                border: '1px solid var(--cyan-border)',
              }}
            >
              Понятно
            </button>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
